import { createFileRoute, redirect } from "@tanstack/react-router";

// Friendly URL aliases: /admin/live-events → /admin?page=live-events
// Known admin page slugs — must mirror PAGE_KEYS in admin.index.tsx.
const KNOWN_PAGES = new Set<string>([
  "dashboard", "users", "membership", "payments", "listing-fees",
  "admins", "support", "reviews", "cities", "carousels", "settings",
  "eat", "do", "happening", "all", "tickets", "live-events", "lippu",
  "contracts", "business", "landmarks", "backups", "partners", "publish-queue", "crm-users",
]);

// Real sibling routes under /admin/* — these have their own route files and
// must never be redirected into the /admin index switcher.
const REAL_SUBROUTES = new Set<string>([
  "applications", "backups", "city-tiles", "menus", "compress-images", "landmarks", "listing-revisions", "migrate",
  "partner-events", "partners", "seo-fixes", "service-requests", "ticket-routes",
  "train-factory-users",
]);


export const Route = createFileRoute("/_authenticated/admin/$page")({
  beforeLoad: ({ params, location }) => {
    const requested = params.page;
    // If this segment is a real sibling route, forward to it instead of the
    // admin index (avoids the "Unknown admin page" toast on hard-refresh).
    if (REAL_SUBROUTES.has(requested)) {
      throw redirect({ to: `/admin/${requested}` as never, replace: true });
    }
    const known = KNOWN_PAGES.has(requested);
    // eslint-disable-next-line no-console
    console.info("[admin.$page] redirect", {
      requestedPath: location.pathname,
      requestedPage: requested,
      resolvedRoute: "/admin",
      resolvedSearch: known ? { page: requested } : { page: "dashboard", unknown: requested },
    });
    throw redirect({
      to: "/admin",
      search: (known
        ? { page: requested }
        : { page: "dashboard", unknown: requested }) as never,
      replace: true,
    });
  },
});

